import React, {useRef, useState} from 'react';
import { Grid, Box } from '@material-ui/core';
import { withTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
    },
    boxDetailProductTop: {
        width: '100%',
        border: '2px solid #dfdfdf',
        borderRadius: '10px',
        background: '#f9f9f9',
        padding: '2rem 3rem',
        textAlign: 'center'
    }
  }));

const Product = ({ t }) => {
    const classes = useStyles();

  return (
    <div className="relative">
      <Grid container direction="row">
        <Grid container xs={12} md={12}>
            <Box className={classes.boxDetailProductTop}>
                <h1 className='font-size-24 mb-20'>
                    {t('promo.sendMessagePromo')}
                </h1>
                <Grid container direction="row">
                    <Grid xs={12} md={6}>
                        <p className='bold font-size-36 m-0 text-orange'>
                            Rp. 500
                        </p>
                        <p> 
                            {t('promo.priceProviderDesc')} <b>{t('promo.otherProvider')}</b>
                        </p>
                    </Grid>
                    <Grid xs={12} md={6}>
                        <p className='bold font-size-36 m-0'>
                            Rp. 100
                        </p>
                        <p>
                            {t('promo.priceQuickeyDesc')} <b>{t('promo.quickey')}</b>
                        </p>
                    </Grid>
                </Grid>
                <hr className='mb-35'/>
                <Grid container direction="row" >
                    <Grid xs={12} md={4} className='py-10'>
                        <span className="icon-qk-integration font-size-48"></span>
                        <p className='font-size-14 px-3 m-0'>
                            {t('promo.integrateSDK')}
                        </p>
                    </Grid>
                    <Grid xs={12} md={4} className='py-10'>
                        <span className="icon-qk-call-center font-size-48"></span>
                        <p className='font-size-14 px-3 m-0'>
                            {t('promo.customerCare')}
                        </p>
                    </Grid>
                    <Grid xs={12} md={4} className='py-10'>
                        <span className="icon-qk-dashboard font-size-48"></span>
                        <p className='font-size-14 px-3 m-0'>
                            {t('promo.analyticsDashboard')} 
                        </p>
                    </Grid>
                </Grid>
            </Box>
        </Grid>
      </Grid>
  </div>
  );
}
export default withTranslation()(Product);